import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        flexDirection: "row",
        transition: "all 1s ease 0s",
        direction: "ltr",
        display: "flex",
        willChange: "transform",
        transform: "translate(-100%, 0px)",
    },
});

export default function BSL_SlidingView(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    const { index } = props;

    return (
        <div
            className={classes.root}
            style={{ ...props.style, width: "100%", transform: "translate(-" + 100 * index + "%, 0px)" }}
        >
            {props.children}
        </div>
    );
}
